module.exports = __webpack_public_path__ + "img/parallax_valpo.235cb22f.jpg";